<template>
    <div class="view">
        <h2>Formulaire de déclaration des données d'effectifs</h2>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show" v-bind:validated="formSubmitted">
            <b-col cols="10">
                <b-row align-h="end" class="mb-3">
                    <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
                </b-row>
                <b-row align-h="between">
                    <b-col cols="4">
                        <b-form-group id="input-group-marches" label-for="input-marches"  v-if="isAdmin">
                            <template v-slot:label>
                                <label-custom
                                    label="Marché"
                                    :tooltip=libelles.infoBulleNumMarche
                                    :required="true">
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                id="input-marches"
                                :items="marcheIdsItems"
                                v-model="marcheAdmin"
                                @search="onMarcheSearch"
                                :required="true"
                                :disabled="mode === 'UPDATE' || mode === 'READ'"
                                :placeholder=libelles.selectionnerMarche
                            >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <div class="user-info">
                            <p style="margin-bottom: 10px; text-align: center;">
                                <strong>Créateur de la saisie</strong>
                            </p>
                            <template v-if="user.nom.trim() || user.prenom.trim() || user.email.trim()">
                                <p><strong>Nom :</strong> {{ user.nom }}</p>
                                <p><strong>Prénom :</strong> {{ user.prenom }}</p>
                                <p><strong>Email :</strong> {{ user.email }}</p>
                            </template>
                            <template v-else>
                                <p class="no-data">La donnée n’est pas disponible</p>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="5">
                        <b-form-group id="input-group-date" label-for="input-date">
                            <template v-slot:label>
                                <label-custom
                                    label="Données pour le mois"
                                    tooltip="Indiquer le mois concerné par les saisies (n-1 du mois de saisie)"
                                    :required="true">
                                </label-custom>
                            </template>
                            <MonthlyPicker
                                id="input-date"
                                :monthLabels="monthLabels"
                                :nb-months-disabled="isAdmin ? false: 3"
                                v-model="date"
                                :clearOption="false"
                                :disabled="(mode === 'UPDATE' && !isAdminEffectifs) || mode === 'READ'"
                                v-b-modal="'date-modal'"
                            />
                            <div v-if="date && !isBeforeCurrentDate()">
                                <b-modal id="date-modal"
                                         title="Confirmation choix de la date"
                                         ok-title="Confirmer"
                                         cancel-title="Annuler"
                                         @cancel="date=null">La date est postérieur à la date actuelle. voulez-vous
                                    continuer ?
                                </b-modal>
                            </div>
                            <div class="typo-warning" v-if="!isDateFilled">
                                Ce champs est obligatoire
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-card header="Effectifs prévus" class="mb-2">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-nbMaxEffectifCadre" label-for="input-nbMaxEffectifCadre">
                                <template v-slot:label>
                                    <label-custom
                                        label="Effectifs cadre maximal prévu"
                                        :tooltip="effectifs.infobulleNbMaxEffectifCadre"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbMaxEffectifCadre"
                                    v-model="effectifInfos.nbMaxEffectifCadre"
                                    type="number"
                                    min="0"
                                    step="1"
                                    required
                                    :disabled="mode === 'READ' || (mode === 'UPDATE' && !isAdminEffectifs) || (isDisableEffectifMax && !isAdminEffectifs)"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-nbMaxEffectifOuvrier" label-for="input-nbMaxEffectifOuvrier">
                                <template v-slot:label>
                                    <label-custom
                                        label="Effectifs ouvrier maximal prévu"
                                        :tooltip="effectifs.infobulleNbMaxEffectifOuvrier"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbMaxEffectifOuvrier"
                                    v-model="effectifInfos.nbMaxEffectifOuvrier"
                                    type="number"
                                    min="0"
                                    step="1"
                                    required
                                    :disabled="mode === 'READ' || (mode === 'UPDATE' && !isAdminEffectifs) || (isDisableEffectifMax && !isAdminEffectifs)"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card no-body class="mb-2">
                    <b-card-header v-b-tooltip.hover
                                   :title="'Nombre d\'effectifs travaillant pour le projet, incluant notamment :\n'+
'\n'+
'les prestataires sur place (ménage, surveillance etc) ;\n'+
'les prestataires ponctuels (1-10 jours de travail sur les chantiers) ;\n'+
'les transporteurs (notamment évacuation déblais) ;\n'+
'le personnel au siège du mandataire travaillant pour le projet  ;\n'+
'selon visibilité, le personnel des sous-traitants dans les usines travaillant pour le projet.\n'+
'Les trois premières catégories sont à inclure dans le champ «Dont effectifs chantier».'">
                        Effectifs à date
                    </b-card-header>
                    <b-row class="card-body">
                        <b-col>
                            <b-form-group id="input-group-nbEffectifADate" label-for="input-nbEffectifADate">
                                <template v-slot:label>
                                    <label-custom
                                        label="Effectifs projet totaux"
                                        tooltip="Nombre total d'effectifs travaillant sur la partie études et sur les chantiers"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbEffectifADate"
                                    v-model="effectifInfos.nbEffectifADate"
                                    type="number"
                                    min="0"
                                    step="1"
                                    required
                                    :state="isLessThen(effectifInfos.nbEffectifADate, effectifInfos.nbDontEffectifChantier)"
                                    :disabled="mode === 'READ'"></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-nbEffectifEnCumule" label-for="input-nbEffectifEnCumule">
                                <template v-slot:label>
                                    <label-custom
                                        label="Effectifs en cumulé"
                                        tooltip=" Le nombre total de personnes présentes depuis le début du chantier"
                                    >
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbEffectifEnCumule"
                                    v-model="effectifInfos.nbEffectifEnCumule"
                                    type="number"
                                    min="0"
                                    step="1"
                                    :disabled="mode === 'READ'"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-nbDontEffectifChantier"
                                          label-for="input-nbDontEffectifChantier">
                                <template v-slot:label>
                                    <label-custom
                                        label="Dont effectifs chantier"
                                        tooltip="Nombre d'effectifs travaillant sur les chantiers. Si la phase études du marché est terminée, ce nombre peut être égal au nombre total d'effectifs du projet"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbDontEffectifChantier"
                                    v-model="effectifInfos.nbDontEffectifChantier"
                                    type="number"
                                    min="0"
                                    step="1"
                                    required
                                    :state="isLessThen(effectifInfos.nbEffectifADate, effectifInfos.nbDontEffectifChantier)"
                                    :disabled="mode === 'READ'"></b-form-input>
                                <b-form-invalid-feedback id="input-nbDontEffectifChantier">
                                    Doit être inférieur ou égal à effectifs projet totaux
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group id="input-group-nbEffectifCumuleM1"
                                          label-for="input-nbEffectifCumuleM1">
                                <template v-slot:label>
                                    <label-custom
                                        :label="`Effectifs en cumulé M-${nbMonthSinceLastReporting}`"
                                        tooltip="Nombre total cumulé de personnes présentes le mois dernier"
                                        :required="false">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbEffectifCumuleM1"
                                    v-model="effectifInfos.nbEffectifCumuleM1"
                                    type="number"
                                    min="0"
                                    step="1"
                                    readonly
                                    :disabled="true"></b-form-input>
                            </b-form-group>

                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-nbTravDetach" label-for="input-nbTravDetach">
                                <template v-slot:label>
                                    <label-custom
                                        label="Travailleurs détachés (projet total)"
                                        :tooltip="effectifs.infoBulleNbTravDetach"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbTravDetach"
                                    v-model="effectifInfos.nbTravDetach"
                                    type="number"
                                    min="0"
                                    step="1"
                                    required
                                    :disabled="mode === 'READ'"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card no-body class="mb-2">
                    <b-card-header header-tag="header" v-b-tooltip.hover
                                   :title="'inclure les effectifs groupement & intérimaires'">
                        Groupement & intérimaires (projet total)
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupCadreFem"
                                                  label-for="input-nbEmploiGroupCadreFem">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement cadre féminins"
                                                tooltip="Indiquer les effectifs cadre féminins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupCadreFem"
                                            v-model="effectifInfos.nbEmploiGroupCadreFem"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupCadreMasc"
                                                  label-for="input-nbEmploiGroupCadreMasc">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement cadre masculins"
                                                tooltip="Indiquer les effectifs cadre masculins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupCadreMasc"
                                            v-model="effectifInfos.nbEmploiGroupCadreMasc"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupCadre"
                                                  label-for="input-nbEmploiGroupCadre">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement cadre"
                                                tooltip="Indiquer les effectifs cadre du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupCadre"
                                            v-model="effectifInfos.nbEmploiGroupCadre"
                                            type="number"
                                            min="0"
                                            step="1"
                                            disabled></b-form-input>
                                    </b-form-group>
                                </b-row>
                            </b-col>
                            <b-col>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupEtamFem"
                                                  label-for="input-nbEmploiGroupEtamFem">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ETAM féminins"
                                                tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse féminins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupEtamFem"
                                            v-model="effectifInfos.nbEmploiGroupEtamFem"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupEtamMasc"
                                                  label-for="input-nbEmploiGroupEtamMasc">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ETAM masculins"
                                                tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse masculins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupEtamMasc"
                                            v-model="effectifInfos.nbEmploiGroupEtamMasc"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupEtam"
                                                  label-for="input-nbEmploiGroupEtam">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ETAM"
                                                tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupEtam"
                                            v-model="effectifInfos.nbEmploiGroupEtam"
                                            type="number"
                                            min="0"
                                            step="1"
                                            disabled></b-form-input>
                                    </b-form-group>
                                </b-row>
                            </b-col>
                            <b-col>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupOuvrierFem"
                                                  label-for="input-nbEmploiGroupOuvrierFem">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ouvrier féminins"
                                                tooltip="Indiquer les effectifs ouvriers féminins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupOuvrierFem"
                                            v-model="effectifInfos.nbEmploiGroupOuvrierFem"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupOuvrierMasc"
                                                  label-for="input-nbEmploiGroupOuvrierMasc">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ouvrier masculins"
                                                tooltip="Indiquer les effectifs ouvriers masculins du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupOuvrierMasc"
                                            v-model="effectifInfos.nbEmploiGroupOuvrierMasc"
                                            type="number"
                                            min="0"
                                            step="1"
                                            @change="updateFields"
                                            :disabled="mode === 'READ'"></b-form-input>
                                    </b-form-group>
                                </b-row>
                                <b-row>
                                    <b-form-group id="input-group-nbEmploiGroupOuvrier"
                                                  label-for="input-nbEmploiGroupOuvrier">
                                        <template v-slot:label>
                                            <label-custom
                                                label="Effectifs groupement ouvrier"
                                                tooltip="Indiquer les effectifs ouvriers du groupement pour le mois en cours"
                                                :required="false">
                                            </label-custom>
                                        </template>
                                        <b-form-input
                                            id="input-nbEmploiGroupOuvrier"
                                            v-model="effectifInfos.nbEmploiGroupOuvrier"
                                            type="number"
                                            min="0"
                                            step="1"
                                            disabled></b-form-input>
                                    </b-form-group>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>

                <b-card header="Sous-traitants (chantiers uniquement)" class="mb-2">
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantCadreFem"
                                              label-for="input-nbEmploiSousTraitantCadreFem">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant cadre féminins"
                                            tooltip="Indiquer les effectifs cadre féminins chez les sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantCadreFem"
                                        v-model="effectifInfos.nbEmploiSousTraitantCadreFem"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantCadreMasc"
                                              label-for="input-nbEmploiSousTraitantCadreMasc">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant cadre masculins"
                                            tooltip="Indiquer les effectifs cadre masculins chez les sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantCadreMasc"
                                        v-model="effectifInfos.nbEmploiSousTraitantCadreMasc"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantCadre"
                                              label-for="input-nbEmploiSousTraitantCadre">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant cadre"
                                            tooltip="Indiquer les effectifs cadre chez les sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantCadre"
                                        v-model="effectifInfos.nbEmploiSousTraitantCadre"
                                        type="number"
                                        min="0"
                                        step="1"
                                        disabled></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-col>
                        <b-col>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantEtamFem"
                                              label-for="input-nbEmploiSousTraitantEtamFem">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ETAM féminins"
                                            tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse féminins des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantEtamFem"
                                        v-model="effectifInfos.nbEmploiSousTraitantEtamFem"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantEtamMasc"
                                              label-for="input-nbEmploiSousTraitantEtamMasc">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ETAM masculins"
                                            tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse masculins des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantEtamMasc"
                                        v-model="effectifInfos.nbEmploiSousTraitantEtamMasc"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantEtam"
                                              label-for="input-nbEmploiSousTraitantEtam">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ETAM"
                                            tooltip="Indiquer les effectifs employés, technicien et Agent de maitrîse des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantEtam"
                                        v-model="effectifInfos.nbEmploiSousTraitantEtam"
                                        type="number"
                                        min="0"
                                        step="1"
                                        disabled></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-col>
                        <b-col>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantOuvrierFem"
                                              label-for="input-nbEmploiSousTraitantOuvrierFem">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ouvrier féminins"
                                            tooltip="Indiquer les effectifs ouvrier féminins des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantOuvrierFem"
                                        v-model="effectifInfos.nbEmploiSousTraitantOuvrierFem"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantOuvrierMasc"
                                              label-for="input-nbEmploiSousTraitantOuvrierMasc">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ouvrier masculins"
                                            tooltip="Indiquer les effectifs ouvrier masculins des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantOuvrierMasc"
                                        v-model="effectifInfos.nbEmploiSousTraitantOuvrierMasc"
                                        type="number"
                                        min="0"
                                        step="1"
                                        @change="updateFields"
                                        :disabled="mode === 'READ'"></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-nbEmploiSousTraitantOuvrier"
                                              label-for="input-nbEmploiSousTraitantOuvrier">
                                    <template v-slot:label>
                                        <label-custom
                                            label="Effectifs sous-traitant ouvrier"
                                            tooltip="Indiquer les effectifs ouvrier des sous-traitants pour le mois en cours"
                                            :required="false">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                        id="input-nbEmploiSousTraitantOuvrier"
                                        v-model="effectifInfos.nbEmploiSousTraitantOuvrier"
                                        type="number"
                                        min="0"
                                        step="1"
                                        disabled></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card header="Heures (en cumulé depuis le début du marché)" class="mb-2">
                    <b-row v-if="effectifInfos.nbHeureChantier && !effectifInfos.nbHeureMois">
                        <b-col>
                            <b-form-group id="input-group-nbHeureMois" label-for="input-nbHeureMois">
                                <template v-slot:label>
                                    <label-custom
                                        label="Heures effectuées sur le marché (cumulé)"
                                        tooltip="Nombre total d’heures de travail effectuées pour le marché, en cumulé depuis le début du marché"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbHeureMois"
                                    v-model="effectifInfos.nbHeureChantier"
                                    type="number"
                                    min="0"
                                    step="any"
                                    required
                                    :disabled="mode === 'READ'">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col>
                            <b-form-group id="input-group-nbHeureMois" label-for="input-nbHeureMois">
                                <template v-slot:label>
                                    <label-custom
                                        label="Heures effectuées sur le mois"
                                        tooltip="Nombre d’heures de travail effectuées pour le marché sur le mois"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbHeureMois"
                                    v-model="effectifInfos.nbHeureMois"
                                    type="number"
                                    min="0"
                                    step="any"
                                    required
                                    :disabled="mode === 'READ'">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group id="input-group-nbHeureTotal" label-for="input-nbHeureTotal">
                                <template v-slot:label>
                                    <label-custom
                                        label="Heures effectuées sur le marché (cumulé)"
                                        tooltip="Nombre total d’heures de travail effectuées pour le marché, en cumulé depuis le début du marché"
                                        :required="true">
                                    </label-custom>
                                </template>
                                <b-form-input
                                    id="input-nbHeureTotal"
                                    :value="nbHeureTotal"
                                    type="number"
                                    min="0"
                                    step="any"
                                    required
                                    :disabled="true">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" v-if="mode === 'CREATE'">
                            <b-form-group
                                id="input-group-fichier-justificatif"
                                :label="libelles.fichierJustificatif"
                                label-for="input-fichier-justificatif"
                            >
                                <template v-slot:label>
                                    <label-custom
                                        :label="effectifs.libellePieceJustificative"
                                        :tooltip="effectifs.infoBullePieceJustificative"
                                    >
                                    </label-custom>
                                </template>
                                <b-form-file
                                    v-model="effectifInfos.pieceJustificative"
                                    accept=".pdf"
                                    drop-placeholder="Déposer le fichier ici"
                                    placeholder="Choisir une pièce justificative"
                                    browse-text="Importer une pièce justificative"
                                ></b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>

                <b-row v-if="mode !== 'CREATE'">
                    <b-col>
                        <b-form-group id="input-group-commentaire" label="Commentaire"
                                      label-for="input-commentaire"
                                      :label-class="effectifInfos.jourSoumissionPassed ? 'typo-required-field' : ''">
                            <b-form-textarea
                                id="input-commentaire"
                                v-model="effectifInfos.commentaire"
                                rows="3"
                                max-rows="5"
                                :required="effectifInfos.jourSoumissionPassed"
                                :disabled="mode === 'READ'"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6" v-if="effectifInfos.statut === 'REFUSE'">
                        <b-form-group
                            id="input-group-commentaire-statut"
                            :label=libelles.commentaireStatut
                            label-for="input-commentaire-statut"
                        >
                            <b-form-textarea
                                id="input-commentaire"
                                :value="effectifInfos.commentaireStatut"
                                rows="3"
                                max-rows="5"
                                disabled
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="pt-2" v-if="mode !== 'READ'">
                    <b-button type="submit" variant="primary" @click="formSubmitted = true"
                              :disabled="!isLessThen(effectifInfos.nbEffectifADate, effectifInfos.nbDontEffectifChantier)">
                        Soumettre
                    </b-button>
                    <b-button v-if="mode === 'CREATE'" type="reset" variant="danger">Réinitialiser</b-button>
                </div>

                <div class="pt-2" v-if="mode === 'READ' && isAdminEffectifs">
                    <b-button
                        v-if="effectifInfos.statut === 'ATTENTE_MODIFICATION' || effectifInfos.statut === 'ATTENTE_SUPPRESSION'"
                        type="button" variant="primary" @click="validerEffectifInfos(effectifInfos)">
                        <span v-if="effectifInfos.statut === 'ATTENTE_MODIFICATION'">Confirmer la modification</span>
                        <span v-if="effectifInfos.statut === 'ATTENTE_SUPPRESSION'">Confirmer la suppression</span>
                    </b-button>
                </div>

            </b-col>

        </b-form>
        <br/>
    </div>

</template>

<script>
import MarcheEffectifInfosDto from "../../dtos/MarcheEffectifInfosDto";
import SessionStore from '@/stores/SessionStore'
import hasPermission from "../../filters/hasPermission";
import MarcheStore from "../../stores/MarcheStore";
import MarcheEffectifInfosStore from "../../stores/MarcheEffectifInfosStore";
import LabelCustom from "../../components/LabelCustom";
import moment from 'moment';
import {mois} from "../../constants/enums";
import {sum} from "../../utils/mathUtil";
import {momentToDate, nbMonthsBetweenDates} from "../../utils/dateUtil";
import {effectifs} from "../../constants/libelles"
import {libelles} from '../../constants/libelles';
import {EventBus} from '@/event-bus';
import {string2literal} from "../../utils/stringUtil";
import AlertStore from "@/stores/AlertStore";
import AutocompleteCustom from "../../components/AutocompleteCustom";
import _ from 'lodash';
import MonthlyPicker from "@/components/MonthlyPicker.vue";

export default {
    components: {MonthlyPicker, LabelCustom, AutocompleteCustom},
    data() {
        return {
            formSubmitted: false,
            show: true,
            sessionStoreState: SessionStore.state,
            effectifInfos: new MarcheEffectifInfosDto(),
            date: null,
            monthLabels: mois,
            marcheAdmin: null,
            marchesAdmin: [],
            marches: [],
            isDisableEffectifMax: false,
            initNbHeureMois: 0,
            effectifs: effectifs,
            libelles: libelles,
            marcheIdsItems: [],
        }
    },
    computed: {
        user() {
        if(this.mode === 'CREATE'){
            return {
                email: SessionStore.state.email,
                prenom: SessionStore.state.prenom,
                nom: SessionStore.state.nom
            }
        }
        return{
                email: this.effectifInfos.user?.email || " ",
                prenom: this.effectifInfos.user?.prenom || " ", 
                nom: this.effectifInfos.user?.nom || " "
            }  
        },
        nbMonthSinceLastReporting() {
            return nbMonthsBetweenDates(this.date, this.effectifInfos.lastEffectifDate)
        },
        mode() {
            return !this.$route.params.id ? 'CREATE' : (this.effectifInfos.statut === 'VALIDE' && !hasPermission(["CORRESPONDANT_EFFECTIFS_LECTURE"])) ? 'UPDATE' : 'READ';
        },
        isAdminEffectifs() {
            return hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR']);
        },
        isAdmin() {
            return this.isAdminEffectifs && !this.sessionStoreState.marches.length;
        },
        nbHeureTotal() {
            return sum([this.effectifInfos.nbHeureTotal || 0, this.effectifInfos.nbHeureMois || 0]) || null
        },
        isDateFilled() {
            return this.formSubmitted ? this.date != null && this.date._isValid : true;
        },
        marcheId() {
            return this.isAdmin ? this.marcheAdmin : this.sessionStoreState.marche.id;
        },
        computedEffectifInfos() {
            return Object.assign({}, this.effectifInfos);
        },
    },
    watch: {
        $route() {
            this.initEffectifInfos();
        },
        computedEffectifInfos: {
            handler: function (newVal, oldVal) {
                if (this.mode === 'CREATE' && !_.isEqual(oldVal, newVal) && oldVal.nbMaxEffectifCadre === newVal.nbMaxEffectifCadre && oldVal.nbEffectifADate === newVal.nbEffectifADate && oldVal.nbEffectifCumuleM1 === newVal.nbEffectifCumuleM1) {
                    localStorage.effectifInfos = JSON.stringify(newVal);
                }
            },
            deep: true,
        },
        date(newDate) {
            if (newDate && newDate._isValid) {
                if (this.mode === 'CREATE') {
                    localStorage.dateEffectifInfos = newDate;
                }
                this.search();
            }
        },
        marcheAdmin(newMarcheAdmin) {
            this.onMarcheSearch(newMarcheAdmin, true);
            this.search();
            if (this.mode === 'CREATE') {
                localStorage.marcheAdminEffectifInfos = newMarcheAdmin;
            }
        },
        isDisableEffectifMax(newVal) {
            if (this.mode === 'CREATE') {
                localStorage.isDisableEffectifMax = newVal;
            }
        }
    },
    mounted() {
        if (this.isAdmin) {
            MarcheStore.getAll().then(marches => {
                this.marches = marches;
                this.marchesAdmin = marches.map(marche => {
                    return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
                });
                this.marcheIdsItems = this.marchesAdmin;
            });
        } else {
            this.search();
            EventBus.$on('NavBar-marcheChange', () => {
                MarcheEffectifInfosStore.clearLocalStorage();
                this.search();
                this.initEffectifInfos();
            });
        }
        this.initEffectifInfos();
    },
    beforeDestroy() {
        EventBus.$off("NavBar-marcheChange");
    },
    methods: {
        initEffectifInfos() {
            this.marcheAdmin = null;
            this.date = null;
            this.formSubmitted = false;
            this.show = false;
            this.$nextTick(() => {
                this.show = true
            });
            if (this.mode !== 'CREATE') {
                MarcheEffectifInfosStore.get(this.$route.params.id).then(value => {
                    if (value) {
                        this.initNbHeureMois = value.nbHeureMois;
                        this.effectifInfos = value;
                        this.date = moment(value.date);
                        this.marcheAdmin = value.marche.id;
                    }
                });
            } else {
                this.getLocalStorage();
            }
        },
        updateFields() {
            this.effectifInfos.nbEmploiGroupCadre = this.sum([this.effectifInfos.nbEmploiGroupCadreMasc, this.effectifInfos.nbEmploiGroupCadreFem]);
            this.effectifInfos.nbEmploiGroupEtam = this.sum([this.effectifInfos.nbEmploiGroupEtamMasc, this.effectifInfos.nbEmploiGroupEtamFem]);
            this.effectifInfos.nbEmploiGroupOuvrier = this.sum([this.effectifInfos.nbEmploiGroupOuvrierMasc, this.effectifInfos.nbEmploiGroupOuvrierFem]);
            this.effectifInfos.nbEmploiSousTraitantCadre = this.sum([this.effectifInfos.nbEmploiSousTraitantCadreMasc, this.effectifInfos.nbEmploiSousTraitantCadreFem]);
            this.effectifInfos.nbEmploiSousTraitantEtam = this.sum([this.effectifInfos.nbEmploiSousTraitantEtamMasc, this.effectifInfos.nbEmploiSousTraitantEtamFem]);
            this.effectifInfos.nbEmploiSousTraitantOuvrier = this.sum([this.effectifInfos.nbEmploiSousTraitantOuvrierMasc, this.effectifInfos.nbEmploiSousTraitantOuvrierFem]);
        },
        sum(fields) {
            return sum(fields);
        },
        checkEffectifVariation() {
            // l'effectif cumulé actuel et celui du mois précédent
            const effectifActuel = this.effectifInfos.nbEffectifEnCumule;
            const effectifPrecedent = this.effectifInfos.nbEffectifCumuleM1;

            // la contrainte
            if (effectifActuel && effectifPrecedent) {
                const variation = effectifActuel / effectifPrecedent;
                if (variation > 10) {
                    AlertStore.pushError("L'effectif ne doit pas être supérieur à 10 fois l'effectif du mois précédent.");
                    return false; // Interrompre la soumission
                }
            }
            return true;
        },
        onSubmit(evt) {
            evt.preventDefault();
            if (!this.checkEffectifVariation()) {
                return;
            }
            if (!this.isDateFilled) {
                AlertStore.pushError('Mois non renseigné');
                return;
            }
            this.submitInfos();
        },
        submitInfos() {
            this.effectifInfos.date = momentToDate(this.date);
            if (this.mode === 'CREATE') {
                this.effectifInfos.marche = this.isAdmin ? this.marches.find(marche => marche.id === this.marcheAdmin) : this.sessionStoreState.marche;
                MarcheEffectifInfosStore.create(this.effectifInfos);
            } else {
                MarcheEffectifInfosStore.update(this.effectifInfos);
            }
        },
        onReset(evt) {
            evt.preventDefault();
            MarcheEffectifInfosStore.clearLocalStorage();
            this.initEffectifInfos();
        },
        validerEffectifInfos(effectifInfos) {
            MarcheEffectifInfosStore.validate(effectifInfos).then(() => {
                this.$router.push("/marche-effectif-infos/validation");
            });
        },
        search() {
            if (this.marcheId && this.date) {
                MarcheEffectifInfosStore.getLatestByMarcheAndStatuts(this.marcheId, momentToDate(this.date)
                ).then((result) => {
                    if (result) {
                        this.effectifInfos = {
                            ...this.effectifInfos,
                            nbHeureTotal: result.nbHeureTotal,
                            nbEffectifCumuleM1: result.nbEffectifEnCumule,
                            lastEffectifDate: new Date(result.date),
                            ...this.effectifsMaxPrevus(result.nbMaxEffectifCadre, result.nbMaxEffectifOuvrier)
                        };
                        this.isDisableEffectifMax = true;
                    } else {
                        this.effectifInfos = {
                            ...this.effectifInfos,
                            nbHeureTotal: null,
                            nbEffectifCumuleM1: null,
                            lastEffectifDate: null,
                            ...this.effectifsMaxPrevus(null, null)
                        }
                        this.isDisableEffectifMax = false;
                    }
                });
            } else {
                this.effectifInfos = {
                    ...this.effectifInfos,
                    nbHeureTotal: null,
                    nbEffectifCumuleM1: null,
                    lastEffectifDate: null,
                    ...this.effectifsMaxPrevus(null, null)
                }
                this.isDisableEffectifMax = false;
            }
        },
        // En modification, on conserve les effectifs max de la donnée chargée au lieu de reprendre ceux du mois précédent
        effectifsMaxPrevus(nbMaxEffectifCadre, nbMaxEffectifOuvrier) {
            if (this.mode !== 'CREATE') {
                return {};
            }
            return {nbMaxEffectifCadre, nbMaxEffectifOuvrier};
        },
        isFilledInput(value) {
            return value != null && value !== "";
        },
        isLessThen(value, lessValue) {
            if (this.isFilledInput(value) && this.isFilledInput(lessValue)) {
                return (Number(lessValue) <= Number(value))
            }
            return null;
        },
        getLocalStorage() {
            if ((localStorage.effectifInfos && localStorage.effectifInfos !== "{}") || string2literal(localStorage.dateEffectifInfos) || string2literal(localStorage.marcheAdminEffectifInfos)) {
                if (localStorage.effectifInfos && localStorage.effectifInfos !== "{}") {
                    Object.assign(this.effectifInfos, {
                        ...JSON.parse(localStorage.effectifInfos),
                        nbHeureChantier: null,
                        pieceJustificative: null
                    });
                    this.effectifInfos.id = null;
                }
                this.date = moment(new Date(localStorage.dateEffectifInfos));
                this.marcheAdmin = parseInt(localStorage.marcheAdminEffectifInfos);
                this.isDisableEffectifMax = Boolean(localStorage.isDisableEffectifMax);
                AlertStore.pushSuccess(libelles.messageLocalStorage);
            } else {
                this.effectifInfos = new MarcheEffectifInfosDto();
            }
        },
        onMarcheSearch(marche, isId) {
            this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
        },
        isBeforeCurrentDate() {
            var currentdate = new Date();
            if (this.date) {
                return momentToDate(this.date) < currentdate;
            }
        }
    }
}
</script>
<style>
    .user-info {
        background-color: #f0f0f0;
        padding: 10px;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        box-sizing: border-box;
        word-break: break-word;
    }
    .no-data {
        text-align: center;
        font-style: italic;
        color: #888;
    }
</style>
